import http from "./http";
import apis from "../config/apis.json";

const api = 
    process.env.REACT_APP_ENVIRON === "development"
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === "production"
    ? apis.prod
    : apis.test;

// Create a checkout session for adding credits
export async function createCheckoutSession(organizationId) {
    const response = await http.post(`${api}/checkout/${organizationId}/create-session`);
    return response;
}

// Create a setup session for configuring payment methods
export async function createSetupSession(organizationId) {
    const response = await http.post(`${api}/checkout/${organizationId}/setup-session`);
    return response;
}

// Get the payment method for the organization
export async function getPaymentMethod(organizationId) {
    const response = await http.get(`${api}/checkout/${organizationId}/payment-method`);
    return response;
}

// Delete the payment method
export async function deletePaymentMethod(organizationId) {
    const response = await http.delete(`${api}/checkout/${organizationId}/payment-method`);
    return response;
}
